function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v82H0z",
  opacity: 0.4,
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.572 23c.365 0 .731.135 1.01.405.557.541.557 1.418 0 1.959L18.448 40.999l16.134 15.637c.557.54.557 1.418 0 1.959-.558.54-1.462.54-2.02 0L15.419 41.979a1.354 1.354 0 010-1.958l17.143-16.616c.279-.27.644-.405 1.01-.405z",
  fill: "#FFF"
}));

function SvgGalleryArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 82",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGalleryArrowLeft;